export default "__VITE_ASSET__Brkk8SI3__"